import { createGlobalStyle } from "styled-components";
import { withTheme } from "@material-ui/styles";
import gradientBackground from "./gradientBackground";

const GlobalStyle = withTheme(createGlobalStyle`
  html, body {
    margin: 0;
    height: 100%;
    width: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${gradientBackground}
  }

  #root {

    height: 100%;
  }
`);

export default GlobalStyle;
